module.exports = __webpack_public_path__ + "images/city_l.06b4fb88da59af5d3daef54c2110defc.png";